import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const CommentsTitle = () => {
  return (
    <Box flexDirection="row" gap="s8" alignItems="center" paddingBottom="s16">
      <Text size="300" weight="semibold" color="textPrimary">
        {i18n.t('comments.title.default')}
      </Text>
    </Box>
  )
}

export default CommentsTitle
